import { CurrencyPipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { CartBillService } from 'src/app/shared/services';

@Component({
    selector: 'app-lib-awb',
    templateUrl: './awb.component.html',
    styleUrls: ['./awb.component.scss'],
    standalone: true,
    imports: [CurrencyPipe],
})
export class AwbComponent implements OnInit, OnDestroy {
    private unsubscribe$: Subject<void>;
    public total: number;

    @Input() awb: string;

    constructor(private cartService: CartBillService) {
        this.unsubscribe$ = new Subject<void>();
    }

    ngOnInit(): void {
        this.subscribeTotal();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    subscribeTotal(): void {
        this.cartService
            .getTotalByAWB(this.awb)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: (total) => {
                    this.total = total;
                },
            });
    }
}
